import styled, { css } from "styled-components";

import { colors } from 'pages/Quotes/styles/colors';
import { Row } from "components/Layout/Grid";

interface StatusColorExpirationDateProps {
  variant: string | number;
}

export const StatusDaysToExpire = styled.span<StatusColorExpirationDateProps>`
  width: 0.5rem;
  height: 0.5rem;

  border-radius: 50%;
  margin-right: 0.625rem;

  ${props => Number(props.variant) > 0 && Number(props.variant) <= 15 && css`
    background: #D31C11
  `}

  ${props => Number(props.variant) > 15 && Number(props.variant) <= 30 && css`
    background: ${colors.yellow};
  `}

  ${props => Number(props.variant) > 30 && Number(props.variant) <= 60 && css`
    background: #738DB3
  `}
`;

export const DivStopWatch = styled(Row)`
    gap: 10px;
    font-size: 0.875rem;
    font-style: italic;
    justify-content: end;

    padding-top: 0.938rem;
`;